import React, { useState } from 'react';
import Result from './Result';

const Results = ({ currentData, count }) => (
  <div className="results-container">
    {count === 0 && (
      <div className="empty-results">
        <h3>No Results Found</h3>
        <p>Please choose a new filter to reset.</p>
      </div>
    )}
    <div className="results">
      {Object.keys(currentData) &&
        Object.keys(currentData).map((key) => (
          <article
            key={key}
            className="result node node--type-product node--view-mode-card"
            data-active={currentData[key].active}
          >
            <Result currentData={currentData} index={key} />
          </article>
        ))}{' '}
    </div>
  </div>
);

export default Results;
